/* eslint-disable space-before-function-paren */
import React from 'react'
import {
  faFacebook,
  faLinkedinIn,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'
import insta from '../../images/icon/instafooter.svg'
import { graphql, useStaticQuery } from 'gatsby'
import Logo from '../../images/icon/logo1-branco.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as styles from './footer.module.scss'
import { useIntl, Link } from 'gatsby-plugin-react-intl'
import IconPonto from '../../images/footer/selo_perto_digital.png'

export default function Footer() {
  const data = useStaticQuery(
    graphql`
    query {
      arquivo:contentfulDocumentos(categoria: {eq: "politica-gestao"}) {
        arquivo {
          file {
            url
          }
        }
      }
    }
  `)
  const date = new Date()
  const year = date.getFullYear()
  const intl = useIntl()

  return (
    <>
      <footer className="bg-lwart-darkblue">
        <div className="container d-lg-block d-none">
          <div className="row py-4">
            <div className="col-md-4 d-flex flex-column align-items-center">
              <img src={Logo} className="w-65 h-90 mb-2" alt="Logo Lwart em Branco" />
            </div>
            <div className="col-md-4 d-flex align-items-center justify-content-center">
              <ul className="mb-0">
                <li><Link to="/nossa-essencia/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link1' })}</Link></li>
                {/* <li><Link to="/nossas-solucoes/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link2' })}</Link></li> */}
                <li><Link to="/coleta-de-oleo-lubrificante-usado/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link3' })}</Link></li>
                <li><Link to="/oleos-de-alta-performance/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link4' })}</Link></li>
                {/* <li><Link to="/gestao-de-residuos/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link5' })}</Link></li> */}
                <li><Link to="/sustentabilidade/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link6' })}</Link></li>
                {
                  intl.locale === 'pt'
                    ? <>
                      <li><Link to="/informacoes-financeiras/" className={styles.ancoraFooter}>Relacionamento com Investidor</Link></li>
                      <li><Link to="/fornecedores/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link10' })}</Link></li>
                      <li><Link to="/projeto-h/" className={styles.ancoraFooter}>Projeto H+</Link></li>
                    </>
                    : ''
                }
              </ul>
            </div>
            <div className="col-md-4 d-flex align-items-center justify-content-center">
              <ul className="mb-0">
                {intl.locale === 'pt' &&
                  <li><Link to="/blog/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link7' })}</Link></li>
                }
                <li><Link to="/gente/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link8' })}</Link></li>
                <li><Link to="/fale-com-a-gente/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link9' })}</Link></li>
                <li><a href={data.arquivo.arquivo.file.url} target="_blank" rel="noreferrer noopener" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link11' })}</a></li>
                <li><Link to="/politica-de-privacidade/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link12' })}</Link></li>
                <li><Link to="/lei-lgpd/" className={styles.ancoraFooter}>{intl.formatMessage({ id: 'components.footer.link13' })}</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="gradient-blue-to-green"
          style={{ minHeight: '80px', display: 'flex', alignItems: 'center' }}
        >
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-12 d-flex d-lg-none justify-content-between align-items-center flex-wrap">
                <div className="d-flex flex-column align-items-start">
                  <p
                    className="m-0 p-0 text-white font-Spinnaker font-weight-bold letter-space-normal mb-2"
                    id={styles.fontCreditos}
                  >
                    © <span className="font-Spinnaker">{year}</span> {intl.formatMessage({ id: 'components.footer.copyright' })}
                  </p>
                  <div className="d-flex gap-3">
                    <a href="https://www.instagram.com/lwartsolucoesambientais/" target="blank" aria-label="Link Instagram">
                      <img src={insta} className={styles.svgIcon} alt="Instagram da Lwart Soluções Ambientais." />
                    </a>
                    <a href="https://www.facebook.com/lwartsolucoesambientais/" target="blank" aria-label="Link Facebook">
                      <FontAwesomeIcon icon={faFacebook} className={styles.svgIcon} />
                    </a>
                    <a href="https://www.linkedin.com/company/lwartsolucoesambientais" target="blank" aria-label="Link Linkedin">
                      <FontAwesomeIcon icon={faLinkedinIn} className={styles.svgIcon} />
                    </a>
                    <a href="https://www.youtube.com/user/grupolwart" target="blank" aria-label="Link Youtube">
                      <FontAwesomeIcon icon={faYoutube} className={styles.svgIcon} />
                    </a>
                  </div>
                </div>
                <div className="mt-3 mt-sm-0">
                  <img
                    src={IconPonto}
                    alt="Ícone ponto retangular"
                    style={{ height: '40px', objectFit: 'contain' }}
                  />
                </div>
              </div>
              <div className="col-lg-4 d-none d-lg-flex align-items-center gap-3">
                <p
                  className="m-0 p-0 text-white font-Spinnaker font-weight-bold letter-space-normal"
                  style={{ whiteSpace: 'nowrap' }}
                  id={styles.fontCreditos}
                >
                  © <span className="font-Spinnaker">{year}</span> {intl.formatMessage({ id: 'components.footer.copyright' })}
                </p>
                <img
                  src={IconPonto}
                  alt="Ícone ponto retangular"
                  style={{ height: '65px', objectFit: 'contain', marginLeft: '24px' }}
                />
              </div>
              <div className="col-lg-4 d-none d-lg-flex justify-content-end align-items-center gap-4">
                <a href="https://www.instagram.com/lwartsolucoesambientais/" target="blank" aria-label="Link Instagram">
                  <img src={insta} className={styles.svgIcon} alt="Instagram da Lwart Soluções Ambientais." />
                </a>
                <a href="https://www.facebook.com/lwartsolucoesambientais/" target="blank" aria-label="Link Facebook">
                  <FontAwesomeIcon icon={faFacebook} className={styles.svgIcon} />
                </a>
                <a href="https://www.linkedin.com/company/lwartsolucoesambientais" target="blank" aria-label="Link Linkedin">
                  <FontAwesomeIcon icon={faLinkedinIn} className={styles.svgIcon} />
                </a>
                <a href="https://www.youtube.com/user/grupolwart" target="blank" aria-label="Link Youtube">
                  <FontAwesomeIcon icon={faYoutube} className={styles.svgIcon} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
